export const BANK_ACCOUNTS = ['Checking', 'Savings'];

export const CLASSIFICATIONS = ['Church', 'Food Bank', 'Sunday School'];

export const TRANSACTION_TYPES = [
  // Income
  { name: 'Offering',    kind: 'income',  classification: 'Church' },
  { name: 'Donation',    kind: 'income',  classification: 'Church' },
  // Expense
  { name: 'Utilities',   kind: 'expense', classification: 'Church' },
  { name: 'Repairs',     kind: 'expense', classification: 'Church' },
  { name: 'Pastor',      kind: 'expense', classification: 'Church' },
  { name: 'Heat',        kind: 'expense', classification: 'Church' },
];

export const DEFAULT_MONTHLY_BUDGETS = {};
